<script lang="ts">
import { h, resolveComponent, defineComponent, type VNode } from 'vue';

import { AccountLayoutMixin } from '@/bundles/App/mixins/accountMixin';

// The v2 functional version borrowed `getAccountRoute` from the parent that
// rendered it; the mixin is carried here so the link does not depend on who
// the parent happens to be.
export default defineComponent({
  name: 'TemporaryPasswordDialog',
  mixins: [AccountLayoutMixin],

  render (): VNode {
    const VDialog = resolveComponent('v-dialog');
    const VCard = resolveComponent('v-card');
    const VCardTitle = resolveComponent('v-card-title');
    const VCardText = resolveComponent('v-card-text');
    const VCardActions = resolveComponent('v-card-actions');
    const VSpacer = resolveComponent('v-spacer');
    const VBtn = resolveComponent('v-btn');

    return h(VDialog, {
      modelValue: true,
      persistent: true,
      maxWidth: 500,
    }, { default: () => [
      h(VCard, null, { default: () => [
        h(VCardTitle, { class: 'headline' }, { default: () => 'Password Change Required' }),
        h(VCardText, null, { default: () => [
          h('p', { class: 'mb-4' }, 'You are currently using a temporary password. For security reasons, you must change your password before continuing.'),
          h('p', { class: 'mb-0' }, 'Click the button below to go to the security settings page where you can update your password.'),
        ] }),
        h(VCardActions, null, { default: () => [
          h(VSpacer),
          h(VBtn, {
            to: this.getAccountRoute({ name: 'user-security' }),
            color: 'primary',
          }, { default: () => 'Change Password' }),
        ] }),
      ] }),
    ] });
  },
});
</script>
